export const IS_TEST_ENV = typeof window !== 'undefined' && window.location?.hostname?.includes?.('test-tamagotchi');
